import { createVersionedComponentLoader } from '../../../../VersionedComponentLoader';
import { VersionedComponents, VersionedContext } from '../../../../constants';
const Contact = ({ version, i18n, contact }) =>
  createVersionedComponentLoader(
    VersionedContext.PREVIEW,
    VersionedComponents.CONTACT
  )(version)({
    i18n,
    contact
  });
export default Contact;
